import clsx from "clsx";
import { type UploadDestination } from "./uploadCoordinator";

interface Props {
  destination: UploadDestination | undefined;
}

export const GlobalDropOverlay = ({ destination }: Props) => {
  const canUpload = destination?.canUpload === true;
  const destinationName = destination?.name;

  return (
    <div
      className="bg-ui-app-background/90 pointer-events-none fixed inset-0 z-50 flex p-3 backdrop-blur-sm sm:p-6 lg:p-8"
      role={canUpload ? "status" : "alert"}
      aria-live={canUpload ? "polite" : "assertive"}
      aria-atomic="true"
    >
      <div
        className={clsx(
          "bg-ui-card-background/95 relative flex min-h-0 flex-1 items-center justify-center rounded-lg border-2 px-5 py-16 text-center shadow-lg sm:px-10",
          canUpload ? "border-midnight-blue-500 text-ui-heading-text" : "border-destructive text-destructive",
        )}
      >
        <div
          aria-hidden="true"
          className={clsx(
            "absolute -top-px left-5 max-w-[calc(100%-2.5rem)] rounded-b-lg border border-t-0 px-4 py-2 text-left sm:left-10",
            canUpload
              ? "border-midnight-blue-500 bg-desert-sand-300 text-midnight-blue-600"
              : "border-destructive bg-destructive text-destructive-foreground",
          )}
        >
          <span className="block text-xxs font-medium uppercase tracking-[0.18em]">Destination folder</span>
          <span className="block truncate text-sm font-semibold">{destinationName ?? "Unavailable"}</span>
        </div>

        {canUpload ? (
          <div className="max-w-xl">
            <p className="text-base font-medium sm:text-lg">Drop to upload to</p>
            <p className="mt-1 break-words text-2xl font-semibold sm:text-3xl">{destinationName}</p>
            <p className="mt-4 text-sm font-normal text-ui-paragraph-text sm:text-base">
              Folder structure will be kept.
            </p>
          </div>
        ) : destination ? (
          <div className="max-w-xl">
            <p className="text-base font-medium sm:text-lg">You do not have permission to upload to</p>
            <p className="mt-1 break-words text-2xl font-semibold sm:text-3xl">{destinationName}</p>
          </div>
        ) : (
          <p className="max-w-xl text-lg font-semibold sm:text-2xl">Upload destination is unavailable</p>
        )}
      </div>
    </div>
  );
};
